import React, { memo } from "react";
import { Box, Typography, Stack } from "@mui/material";

interface FeatureCardProps {
  icon: string;
  title: string;
  description: string;
  comingSoon?: boolean;
}

const FeatureCard = memo(({ icon, title, description, comingSoon }: FeatureCardProps) => {
  return (
    <Stack
      spacing={2.5}
      sx={{
        p: { xs: 4, md: 5 },
        pb: { xs: 5, md: 6 },
        height: "100%",
        backgroundColor: "#fcf2ec",
        borderRadius: "20px",
        // borderBottom: "2px solid #d4c4b5",
      }}
    >
      <Box
        component="img"
        src={icon}
        alt={title}
        sx={{
          width: { xs: 130, md: 150 },
          height: { xs: 130, md: 150 },
          objectFit: "contain",
        }}
      />

      <Box>
        {comingSoon && (
          <Typography
            sx={{
              color: "text.secondary",
              fontWeight: 500,
              fontSize: "0.9rem",
              mb: 0.5,
            }}
          >
            (Coming Soon)
          </Typography>
        )}
        <Typography
          variant="h6"
          sx={{
            color: "primary.main",
            fontWeight: 700,
            fontSize: { xs: "1.15rem", md: "1.3rem" },
            lineHeight: 1.3,
            mb: 1.5,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            fontSize: { xs: "0.95rem", md: "1rem" },
            lineHeight: 1.6,
          }}
        >
          {description}
        </Typography>
      </Box>
    </Stack>
  );
});

export default FeatureCard;
